import { useState, useEffect } from "react";
import {
  Button,
  Col,
  Row,
} from "reactstrap";
import { useTranslation, withTranslation } from "react-i18next";
import {
  addDeposit,
  addForexDeposit,
  paymentGatewayDeposit,
} from "apis/deposit";
import { allowedMethods } from "./Methods/allowedMethods";
import WireTransfer from "./Methods/WireTransfer";
import Others from "./Methods/Others";
import CardWrapper from "components/Common/CardWrapper";
import CustomModal from "components/Common/CustomModal";
import StageTwo from "./StageTwo";
import { useDispatch, useSelector } from "react-redux";
import { fetchWallets, getAccountsStart } from "store/actions";
import OlxForex from "./Methods/OlxForex";
import CompanyCrypto from "./Methods/Crypto";
import UPI from "./Methods/UPI";
import * as content from "content.js";
import { fetchDocsStart } from "../../store/general/documents/actions.js";
import CheckKYC from "./Methods/VisaMaster/CheckKYC.js";
import { uploadPDF } from "../../helpers/UploadPDF.js";
import SelfieCamera from "./Methods/VisaMaster/SelfieCamera/SelfieCamera.js";
import Signature from "./Methods/VisaMaster/Signature/Signature.js";

function Deposit({ isOpen, toggleOpen, type }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  // Selectors
  const { wallets } = useSelector((state) => state?.walletReducer);
  // States
  const [activeStep, setActiveStep] = useState(0);
  const [gateway, setGateway] = useState("");
  const [result, setResult] = useState("");
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  // used to check if amount is less than 15 then raise an error
  const [hoveredPaymentMethod, setHoveredPaymentMethod] = useState();
  const [paymentPayload, setPaymentPayload] = useState({});

  const [isFirstStepValid, setIsFirstStepValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [baseCurrency, setBaseCurrency] = useState("KWD");
  const [targetCurrency, setTargetCurrency] = useState("USD");
  const [finitic_PayUrl, setFiniticPayUrl] = useState(null);
  const [virtual_PayUrl, setVirtualPayUrl] = useState(null);
  const [isVirtualPayLoading, setIsVirtualPayLoading] = useState(true);
  const [cyrafa_PayUrl, setCyrafaPayUrl] = useState(null);
  const { clientData } = useSelector((state) => state.Profile);
  const isContractDepositUploaded = clientData.isContractUploaded == undefined || !clientData.isContractUploaded;

  // Effects
  useEffect(() => {
    if (isOpen) {
      setActiveStep(0);
      setGateway("");
    }
  }, [isOpen]);

  useEffect(() => {
    dispatch(fetchDocsStart());
  }, [dispatch]);
  useEffect(() => {
    if (type === "mt5Deposit") {
      dispatch(getAccountsStart());
    } else if (!wallets) {
      dispatch(fetchWallets());
    }
  }, [type, wallets, dispatch]);

  useEffect(() => {
    if (selectedPaymentMethod == "SADAAD_PAY")
      setBaseCurrency("KWD");
    else
      setBaseCurrency("USD");
  }, [selectedPaymentMethod]);

  // Handlers
  function toggleTab(tab) {
    if (activeStep === 0) {
      setIsFirstStepValid(false);
    }
    if (activeStep !== tab) {
      setActiveStep(tab);
    }
  }

  const stageOnePaymentDetails = () => {
    switch (gateway) {
      case "WIRE_TRANSFER":
        return (
          <WireTransfer t={t} setIsFirstStepValid={setIsFirstStepValid}
            setBaseCurrency={setBaseCurrency} setPaymentPayload={setPaymentPayload} />
        );
      case "FINITIC_PAY":
      case "CYRAFA_PAY":
      case "HESABE":
      case "PAY_DO":
      case "OLX_FOREX":
      case "MBME_PAY":
      case "ENOVIPAY":
      case "SADAAD_PAY":
      case "VIRTUAL_PAY":
      case "DEUS_X":
        return (
          <OlxForex t={t} setIsFirstStepValid={setIsFirstStepValid} />
        );
      case "NETELLER":
      case "MASTERCARD":
      case "SKRILL":
        return (
          <Others t={t} setIsFirstStepValid={setIsFirstStepValid} />
        );
      case "UPI":
        return (
          <UPI t={t} setIsFirstStepValid={setIsFirstStepValid} setBaseCurrency={setBaseCurrency} setPaymentPayload={setPaymentPayload} />
        );
      case "CRYPTO":
        return (
          <CompanyCrypto t={t} setIsFirstStepValid={setIsFirstStepValid} setPaymentPayload={setPaymentPayload} />
        );
      case "VISA_MASTER":
        return (
          <CheckKYC
            t={t}
            setIsFirstStepValid={setIsFirstStepValid}
            setPaymentPayload={setPaymentPayload}
          />
        );
      default:
        return (
          <div className="text-center">
            <h5 className="mb-3">
              {t("Please Select Payment Method")}
            </h5>
          </div>
        );
    }
  };

  function generateRandomNumber() {
    const timestamp = Math.floor(Date.now() / 1000).toString(16);
    const random = "xxxxxxxxxxxxxxxx".replace(/x/g, () =>
      Math.floor(Math.random() * 16).toString(16)
    );
    return (timestamp + random).toLowerCase();
  }
  const submitHandler = async (data) => {
    if (selectedPaymentMethod == "VISA_MASTER") {
      if (type != "mt5Deposit") {
        data.gateway = "VISA_MASTER";
      }
      data.currency = targetCurrency;
      delete data.gateway;

      // Extract billing data from paymentPayload
      const billingData = typeof data.paymentPayload === "string"
        ? JSON.parse(data.paymentPayload)
        : paymentPayload;


      delete data.paymentPayload;
      data.description = data.note;
      delete data.note;

      // Add billing information
      data.email = billingData.email || clientData.email;
      data.address = billingData.address;
      data.city = billingData.city;
      data.postal_code = billingData.postalCode;
      data.country = billingData.country;
      data.name = billingData.firstName + " " + billingData.lastName;

      data.amount = `${data.amount}.00`;
      data.currency = baseCurrency;
      data.number = generateRandomNumber();

    }
    if (selectedPaymentMethod === "MBME_PAY") {
      data.customer_info = {
        name: clientData.firstName + " " + clientData?.lastName,
        mobile_country_code: "+971",
        mobile_number: clientData.phone,
        email: clientData.email,
      };
      data.currency = targetCurrency;
    }
    if (selectedPaymentMethod === "DEUS_X") {
      data.currency = targetCurrency;
      delete data.paymentPayload;
    }

    if (selectedPaymentMethod == "VISA_MASTER" && isContractDepositUploaded) {
      try {
        await uploadPDF();
      } catch (error) {
        console.error("PDF upload failed, but continuing with deposit:", error);
      }
    }

    if (selectedPaymentMethod === "VIRTUAL_PAY") {
      data.customerId = clientData?._id || "";
    }

    if (type === "fiatDeposit") {
      if (["OLX_FOREX", "FINITIC_PAY", "VISA_MASTER", "PAY_DO", "MBME_PAY", "DEUS_X", "SADAAD_PAY", "HESABE", "CYRAFA_PAY", "VIRTUAL_PAY"].includes(selectedPaymentMethod)) {
        paymentGatewayDeposit(data, selectedPaymentMethod).then((res) => {
          setResult(res);
          if (res.isSuccess && ["PAY_DO", "DEUS_X", "SADAAD_PAY"].includes(selectedPaymentMethod)) {
            window.location.href = res.result.url;
            return;
          }
          if (res.isSuccess && selectedPaymentMethod === "VISA_MASTER") {
            window.location.href = res.result.result.checkout_url;
            return;
          }
          if (res.isSuccess && selectedPaymentMethod === "HESABE") {
            window.location.href = res.result.redirectUrl;
            return;
          }
          if (!res.isSuccess && selectedPaymentMethod === "VISA_MASTER") {
            // Show error in modal
            toggleTab(2);
            return;
          }
          if (res.isSuccess && selectedPaymentMethod === "MBME_PAY") {

            window.location.href = res.result.data.payment_link;
            return;
          }
          selectedPaymentMethod !== "VISA_MASTER" && toggleTab(2);
          if (res.isSuccess && ["FINITIC_PAY"].includes(selectedPaymentMethod)) {
            setFiniticPayUrl(res.result.url);
            return;
          }

          if (res.isSuccess && ["CYRAFA_PAY"].includes(selectedPaymentMethod)) {
            setCyrafaPayUrl(res.result.url);
            // window.open(res.result.url, "_blank");
            return;
          }

          if (res.isSuccess && ["VIRTUAL_PAY"].includes(selectedPaymentMethod)) {
            setVirtualPayUrl(res.result);
            return;
          }

        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error("Payment Gateway Error:", err);
          setResult(err);
          toggleTab(2);
        });
      } else {
        addDeposit(data).then((res) => {
          setLoading(false);
          setResult(res);
          toggleTab(2);
        }).catch((err) => {
          setLoading(false);
          setResult(err);
          toggleTab(2);
        });
      }

    } else if (type === "mt5Deposit") {
      if (["FINITIC_PAY", "VISA_MASTER", "PAY_DO", "MBME_PAY", "DEUS_X", "SADAAD_PAY", "HESABE", "CYRAFA_PAY", "VIRTUAL_PAY"].includes(selectedPaymentMethod)) {
        if (selectedPaymentMethod === "DEUS_X") {
          data.currency = targetCurrency;
          delete data.paymentPayload;
        }
        if (selectedPaymentMethod === "VIRTUAL_PAY") {
          data.customerId = clientData?._id || "";
        }
        paymentGatewayDeposit(data, selectedPaymentMethod).then((res) => {
          setResult(res);
          if (res.isSuccess && ["PAY_DO", "DEUS_X", "SADAAD_PAY"].includes(selectedPaymentMethod)) {
            window.location.href = res.result.url;
            return;
          }
          if (res.isSuccess && selectedPaymentMethod === "VISA_MASTER") {
            window.location.href = res.result.result.checkout_url;
            return;
          }
          if (res.isSuccess && selectedPaymentMethod === "HESABE") {
            window.location.href = res.result.redirectUrl;
            return;
          }
          if (!res.isSuccess && selectedPaymentMethod === "VISA_MASTER") {
            // Show error in modal for MT5
            toggleTab(2);
            return;
          }
          selectedPaymentMethod !== "VISA_MASTER" && toggleTab(2);
          if (res.isSuccess && ["FINITIC_PAY"].includes(selectedPaymentMethod)) {
            setFiniticPayUrl(res.result.url);
          }

          if (res.isSuccess && ["CYRAFA_PAY"].includes(selectedPaymentMethod)) {
            setCyrafaPayUrl(res.result.url);
          }

          if (res.isSuccess && ["MBME_PAY"].includes(selectedPaymentMethod)) {

            window.location.href = res.result.data.payment_link;
            return;
          }

          if (res.isSuccess && ["VIRTUAL_PAY"].includes(selectedPaymentMethod)) {
            setVirtualPayUrl(res.result);
            return;
          }

        }).catch((err) => {
          // eslint-disable-next-line no-console
          console.error("MT5 Payment Gateway Error:", err);
          setResult(err);
          toggleTab(2);
        });
      } else {
        addForexDeposit(data).then((res) => {
          setResult(res);
          toggleTab(2);
        }).catch((err) => {
          setResult(err);
          toggleTab(2);
        });
      }
    }
  };

  useEffect(() => {
    if (
      gateway === "VIRTUAL_PAY" &&
      virtual_PayUrl?.paymentUrl &&
      virtual_PayUrl?.form
    ) {
      const form = document.createElement("form");

      form.method = "POST";
      form.action = virtual_PayUrl.paymentUrl;

      // This is the important part
      form.target = "virtualPayFrame";

      Object.entries(virtual_PayUrl.form).forEach(([key, value]) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = key;
        input.value = String(value ?? "");
        form.appendChild(input);
      });
      document.body.appendChild(form);
      form.submit();

      // Hide the loading text after submitting
      setIsVirtualPayLoading(false);

      return () => {
        document.body.removeChild(form);
      };
    }
  }, [gateway, virtual_PayUrl]);

  const steps = [
    {
      header: t("Select Method"),
      content: (
        <>
          <div>
            <div className="mb-0">
              <h6 className="mb-3">
                {t("Select Payment Method")}
              </h6>
              <Row className="justify-content-center payment-methods">
                {
                  allowedMethods
                    // .filter((method) => method.isSandbox ? clientData.email?.includes("mailinator.com") : true)
                    .filter((method) => method.allowed.includes(type))
                    .map((method) => (
                      <Col key={method.gateway} xs={4} lg={2} className="my-2">
                        <div className="d-flex flex-column align-items-center">
                          <button
                            type="button"
                            onClick={() => {
                              setGateway(method.gateway);
                              setSelectedPaymentMethod(method.gateway);
                            }}
                            onMouseEnter={() => { setHoveredPaymentMethod(method.gateway) }}
                            onMouseLeave={() => { setHoveredPaymentMethod() }}
                            className={`btn btn-${selectedPaymentMethod === method.gateway ? "success" : hoveredPaymentMethod === method.gateway ? "default" : "light"} waves-effect waves-light w-sm`}
                            style={{
                              height: "100%",
                              // maxHeight: "80px",
                              width: "100%",
                              maxWidth: "80px",
                            }}
                          >
                            <img
                              src={method.image}
                              style={{
                                objectFit: "cover",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                height: "70px",
                              }}
                            ></img>
                          </button>
                          {
                            method.text ? (
                              <small className="text-muted text-center mt-1">
                                {t(method.text)}
                              </small>
                            ) : null
                          }
                        </div>
                      </Col>
                    ))
                }
              </Row>
            </div>
            {gateway && stageOnePaymentDetails()}
            {gateway === "WIRE_TRANSFER" &&
              <Row>
                <Col xs={12} className="text-center py-2">
                  <h4>{t("Local Bank Deposit Terms & Conditions")}</h4>
                </Col>
                <Col xs={12} className="py-2">
                  <div>
                    <p> {`1. ${t("No cash deposits accepted.")} `}</p>
                    <p> {`2. ${t("No third-party payments allowed. Senders name must match your trading account name.")}`}</p>
                    <p> {`3. ${t("Double-check your account details before making the transaction.")}`}</p>
                    <p> {`4. ${t("Share a screenshot of the transaction with DATE, REFERENCE NUMBER/TRANSACTION ID, BANK NAME & AMOUNT.")} `}</p>
                    <p> {`5. ${t("EM accepts only Bank transfers in your local currency.")}`}</p>
                    <p> {`6. ${t("After a successful transaction, funds will be credited to your trading account within 1-4 hours upon receipt by EM. Delays may occur due to bank or EM verifications. Keep your bank confirmation for reference.")}`}</p>
                    <p> {`7. ${t("You can withdraw funds deposited via Bank transfer to any bank account under your name.")}`}</p>
                    <p> {`8. ${t("Withdrawals must return to the original deposit account. Incoming and outgoing funds must match.")}`}</p>

                  </div>
                </Col>
              </Row>}
            {gateway === "UPI" && <Row>
              <Col xs={12} className="text-center py-2">
                <h4>UPI Deposit Terms & Conditions</h4>
              </Col>
              <Col xs={12} className="py-2">
                <div>
                  <p>{`1. ${content.clientName} accepts only UPI Payment in Indian Rupees (INR).`}</p>
                  <p>{"2. No third-party payments allowed. Senders name must match your trading account name."}</p>
                  <p>{"3. Share a screenshot of the transaction with DATE, REFERENCE NUMBER/TRANSACTION ID, BANK NAME & AMOUNT."}</p>
                  <p>{`4. After a successful transaction, funds will be credited to your trading account and wallet within 1-4 hours upon receipt by ${content.clientName}. Delays may occur due to bank or ${content.clientName} verifications. Keep your bank confirmation for reference.`}</p>
                  <p>{"5. You can withdraw funds deposited via Bank transfer to any bank account under your name."}</p>
                </div>
              </Col>
            </Row>}
            {gateway === "CRYPTO" && <Row>
              <Col xs={12} className="text-center py-2">
                <h4>Crypto Deposit Terms & Conditions</h4>
              </Col>
              <Col xs={12} className="py-2">
                <div>
                  <p>1. Clients can deposit a minimum of 10 USDT-TRC20.</p>
                  <p>2. Deposit Depending on the Blockchain.</p>
                  <p>3. Withdrawal will be allowed in the same mode as deposit is made.</p>
                  <p>4. This is the TRC20 Tether address. Any deposit sent by mistake on another blockchain or to an incompatible address may result in the loss of funds forever.</p>
                  <p>5. At the time of withdrawal, it&apos;s a sole responsibility of the client while providing the Wallet ID.</p>
                </div>
              </Col>
            </Row>}
            <div className="text-center mt-4">
              <Button
                type="submit"
                className="btn btn-success waves-effect waves-light w-lg btn-sm"
                disabled={((gateway === "") || !isFirstStepValid)}
                onClick={() => toggleTab(1)}
              >
                {t("Continue")}
              </Button>
            </div>
          </div>
        </>
      ),
    },


    ...(selectedPaymentMethod === "VISA_MASTER" && isContractDepositUploaded
      ? [
        {
          header: "Signature",
          content: (
            <Signature toggleTab={toggleTab} activeStep={activeStep} />
          ),
        },
      ]
      : []),
    ...(selectedPaymentMethod === "VISA_MASTER" && isContractDepositUploaded
      ? [
        {
          header: "Selfie",
          content: (
            <SelfieCamera toggleTab={toggleTab} activeStep={activeStep} />
          ),
        },
      ]
      : [])
    ,
    {
      header: "Enter Amount",
      content: (
        <StageTwo
          t={t}
          setLoading={setLoading}
          loading={loading}
          toggleTab={toggleTab}
          type={type}
          gateway={gateway}
          handleSubmit={submitHandler}
          paymentPayload={paymentPayload}
          receipt={allowedMethods.find((method) => method.gateway === gateway)?.receipt}
          targetCurrency={targetCurrency}
          baseCurrency={baseCurrency}
        />
      ),
    },
    {
      header: "Deposit status",
      content: (
        <>
          {
            // (gateway === "FINITIC_PAY" || gateway === "PAY_DO" || gateway === "CYRAFA_PAY") ? (

            (gateway === "VIRTUAL_PAY") ? (
              <div className="text-center">
                {isVirtualPayLoading && (
                  <>
                    <h4>Redirecting to payment...</h4>
                    <p>Please wait while we redirect you to the payment page.</p>
                  </>
                )}
                <iframe
                  name="virtualPayFrame"
                  title="Virtual Pay"
                  style={{
                    width: "100%",
                    height: "70vh",
                    border: "none",
                  }}
                />
              </div>
            ) : (gateway === "PAY_DO" || gateway === "CYRAFA_PAY") ? (
              <div>
                {t("Please complete payment")}
                <div className="mt-4 d-flex flex-column align-items-center justify-content-center">
                  <iframe
                    src={cyrafa_PayUrl}
                    title="Cyrafa Pay"
                    style={{
                      width: "100%",
                      height: "70vh",
                    }}
                  />
                  <button className="btn btn-danger text-center" onClick={() => toggleOpen()}>Close</button>
                </div>
              </div>
            ) : (
              <>
                {result.status ? (
                  <>
                    <div className="text-center  mb-4">
                      <h1 className="fs-1 mb-5">
                        {t("Your order has been received, thank you for trading with us.")}
                      </h1>
                      <p>{t("Pending Deposit Thank You")}</p>
                      <p>
                        <span className="positive">
                          {
                            type === "fiatDeposit" ? result?.result?.amount?.$numberDecimal : result?.result?.amount
                          }
                          {
                            " "
                          }
                          {
                            type === "fiatDeposit" ? result?.result?.currency : result?.result?.currency
                          }
                        </span>
                      </p>
                      <span className="text-muted">
                        {t("Your transaction ID is")}
                        {result?.result?.recordId}
                      </span>
                    </div>
                    <CardWrapper className="mb-4">
                      <div className="d-flex align-items-center justify-content-around px-4">
                        <div>
                          <div className="text-muted">{t("Status")}</div>
                          <div className="positive">{t(result?.result?.status)}</div>
                        </div>
                        <div>
                          <div className="text-muted">{t("GATEWAY")}</div>
                          <div>{result.result?.gateway}</div>
                        </div>
                      </div>
                    </CardWrapper>
                  </>
                ) : (
                  <>
                    <div className="text-center  mb-4">
                      <h1 className="fs-1 mb-5">
                        {t("Oops!")} <i className="bx sad"></i>
                      </h1>
                      <p>{t("Your Deposit Request Not Successfully Created")}</p>
                    </div>
                    <CardWrapper className="mb-4">
                      <div className="d-flex align-items-center justify-content-between px-5">
                        <div>
                          <div className="positive">{result.message}</div>
                        </div>
                      </div>
                    </CardWrapper>

                    <div className="text-center">
                      <Button
                        className="btn btn-danger m-2 btn-sm w-lg"
                        onClick={toggleOpen}
                      >
                        {t("Continue")}
                      </Button>
                    </div>
                  </>
                )}
              </>
            )
          }
        </>
      ),
    },
  ];
  return (
    <>
      <CustomModal
        steps={steps}
        isOpen={isOpen}
        toggleOpen={toggleOpen}
        activeStep={activeStep}
        toggleTab={toggleTab}
      ></CustomModal>
    </>

  );
}
export default withTranslation()(Deposit);
